import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import UnstyledLink from "components/common/UnstyledLink";
import React from "react";
import { AppRouteURI } from "router/RoleBasedAccess";
import useStyles from "./Styles";

const ContentView = () => {
  const classes = useStyles();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <Grid item container xs={12} sm={10} lg={10} justify="flex-start">
      <Box px={4} pt={matches ? 0 : 10}>
        <Grid item>
          <Box className={classes.line} />
          <Typography variant="h4" gutterBottom>
            Shared Vision {<br />} Planning Tool
          </Typography>
          <Typography variant="h6" gutterBottom>
            Tagline Lorem ipsum dolor
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation.
          </Typography>
          <UnstyledLink to={AppRouteURI.LOGIN}>
            <Grid container justify={matches ? "flex-start" : "center"}>
              <Button
                className={classes.explore}
                variant="contained"
                color="primary"
              >
                Explore the tool
              </Button>
            </Grid>
          </UnstyledLink>
        </Grid>
      </Box>
    </Grid>
  );
};

export default ContentView;
